import { Injectable } from '@angular/core';
import { CompanySetting } from '@app/models/settings/company-setting.model';
import { AuthService } from '@app/services';
import { isRequiredWith } from '@import/functions/required-humi-columns/is-required-with';
import { ColumnType, HumiColumnConfig } from '@import/interfaces';

@Injectable()
export class ColumnRequiredService {
    columnRequirementConfig: HumiColumnConfig;

    constructor(protected auth: AuthService) {
        // Set Config in resolver
        // fetch use here
        this.initRequirementConfig();
    }

    setConditionallyRequiredColumnTypes(humiColumns: ColumnType[]): void {
        humiColumns
            .filter((humiColumn: ColumnType) => humiColumn.requiredWith)
            .forEach((humiColumn: ColumnType) => {
                humiColumn.conditionallyRequired = isRequiredWith(
                    humiColumn,
                    humiColumns,
                    this.columnRequirementConfig
                );
            });
    }

    private setConfigIsBankingRequired(): void {
        CompanySetting.param('company', this.auth.company.id)
            .where('module', 'EmployeeManagement')
            .with('setting')
            .get()
            .then(([companySettings]) => {
                this.columnRequirementConfig.bankAccounts = companySettings.find(
                    (setting) => setting.setting.name === 'bankingInformation.required'
                ).value;
                // Payment method is also required by the same CompanySetting
                this.columnRequirementConfig.paymentMethod = this.columnRequirementConfig.bankAccounts;
            });
    }

    private initRequirementConfig(): void {
        this.columnRequirementConfig = { bankAccounts: false };
        this.setConfigIsBankingRequired();
    }
}
